import http from './http.js';

export async function fetchPromoCodes(params = {}) {
  return http.get('/admin/promo-codes', { params, withMeta: true });
}

export async function createPromoCode(data) {
  return http.post('/admin/promo-codes', data);
}

export async function updatePromoCode(id, data) {
  return http.put(`/admin/promo-codes/${id}`, data);
}

export async function deletePromoCode(id) {
  return http.delete(`/admin/promo-codes/${id}`);
}

export async function fetchPromotions(params = {}) {
  return http.get('/admin/promotions', { params, withMeta: true });
}

export async function createPromotion(data) {
  return http.post('/admin/promotions', data);
}

export async function updatePromotion(id, data) {
  return http.put(`/admin/promotions/${id}`, data);
}

export async function deletePromotion(id) {
  return http.delete(`/admin/promotions/${id}`);
}

export async function fetchLivePromotion() {
  return http.get('/promo/live');
}

export default {
  fetchPromoCodes,
  createPromoCode,
  updatePromoCode,
  deletePromoCode,
  fetchPromotions,
  createPromotion,
  updatePromotion,
  deletePromotion,
  fetchLivePromotion,
};
